// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fNnLN","input":"styles_input__2WJHe"};